import type { AgentModelDescriptor, AgentModelProvider } from '@commenda/types';
import useSWR from 'swr';

import { listAgentProfileModels } from './agentPlatformApi';

/** The models one agent may run a turn on, in the shape the composer's model menu reads. The set
 * changes only when the platform's model routing does, so it is fetched once per tab. The catalogue
 * says nothing about capabilities, so both flags open as supported; no caller reads them. */
export function useAgentProfileModels(
  profileKey: string,
  isEnabled = true
): {
  models: AgentModelDescriptor[];
  isLoading: boolean;
  error: unknown;
} {
  const { data, isLoading, error } = useSWR(
    isEnabled ? (['agent/profile-models', profileKey] as const) : null,
    ([, key]) => listAgentProfileModels(key),
    { revalidateOnFocus: false, revalidateIfStale: false }
  );

  return {
    models: (data?.models ?? []).map((model) => ({
      id: model.modelId,
      label: model.label,
      provider: model.provider as AgentModelProvider,
      supportsStreaming: true,
      supportsTools: true,
    })),
    isLoading: isEnabled && isLoading,
    error,
  };
}
